import { put } from "redux-saga/effects";
import { normalize } from "normalizr";
import Actions from "modules/entity-repository/entity-repository-actions";

export function* normalizeAndStore(data, schema) {
  const { entities: repository, result } = normalize(data, schema);
  yield put(Actions.Creators.entityRepositoryHasChanged(repository));
  return result;
}



// WEBPACK FOOTER //
// ./src/modules/entity-repository/entity-repository-saga.js